var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[(_vm.showSidebar)?_c('app-sidebar'):_vm._e(),_vm._v(" "),_c('el-main',[_c('router-view',{on:{"login-success":_vm.handleLoginSuccess}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }